import styled from 'styled-components';
import {dFlex, BGImageCenter} from '../../../../../globalVariables/GlobalVariables';

export const container = styled.div<{ $color?: string | null; $expanded?: boolean }>`
    width: 44px;
    flex-shrink: 0;
    align-self: stretch;
    background-color: ${p => p.$color};
    ${dFlex};
    flex-direction: column;
    align-items: center;
    justify-content: ${p => p.$expanded ? 'center' : 'flex-end'};
    padding-bottom: ${p => p.$expanded ? '0' : '6px'};
    border-radius: ${p => p.theme.rtl ? '0 4px 4px 0' : '4px 0 0 4px'};
`;

export const star = styled.div`
    font-size: var(--font-size-h2);
    line-height: 1;
    filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
`;

export const stickerImage = styled.div<{ $image?: string | null }>`
    width: 39px;
    height: 39px;
    border-radius: 50%;
    flex-shrink: 0;
    ${p => BGImageCenter(p.$image, 'cover')}
`;
